import { TermsCopy } from '@components/ui';
import Typography from '@mui/material/Typography';
export function OnlineSalesArbitrationSection(): JSX.Element {
  return (
    <>
      <Typography component="p" sx={{ textTransform: 'uppercase', fontWeight: 700, fontSize: 20, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.onlineSalesArbitration.0" />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.onlineSalesArbitration.1" />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.onlineSalesArbitration.2" />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.onlineSalesArbitration.3" />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.onlineSalesArbitration.4" />
      </Typography>
    </>
  );
}
